module.exports = __webpack_public_path__ + "static/media/abbiamo12.c42851d0.png";